import './AdminLists.scss'
import React, {Component} from 'react'
import {withTranslation} from 'react-i18next'
import {
    Button,
    Icon,
    Input,
    List,
    message,
    Modal,
    notification,
    Progress,
    Select,
    Switch,
    Table,
    Upload
} from 'antd'
import {
    changeAllowNegClientPromise,
    getNegativeListPromise,
    updateNegativeRecordPropmise,
    uploadNegativeListPromise,
    exportNegativeListPromise

} from './promises'
import {ReportService, UploadProgressService} from '../../services'
import {globalContext} from '../../contexts'
import {t} from "i18next";

const {confirm} = Modal;
const resultsPerPage = 10;
const {Option} = Select;

const ALLOWED_EXTENSIONS = ['.xlsx', '.txt'];
const MAX_FILE_SIZE_MB = 100;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 10MB

const emptyFilters = {
    rut: '',
    paterno: '',
    materno: '',
    nombre: '',
    causal: '',
    riesgo: ''
};

class AdminLists extends Component {
    static contextType = globalContext

    state = {
        isDownloading: false,
        isLoading: true,
        isModalUploadVisible: false,
        negativeList: [],
        allowNegAdm: this.props.currentUser.cliente.allowNegAdm,
        resultsCurrentPage: 1,
        resultsTotalNum: -1,
        reportId: null,
        intervalReportId: null,
        filters: emptyFilters,
        uploading: false,
        uploaded: false,
        uploadProgress: 0,
        resultsUpload: [],
        fileList: [],
        pendingFile: null,
        isConfirmModalVisible: false,
        stage: 0,
        exporting: false,
        exportProgress: 0,
        exportError: null,
        downloadingStage: false,
        isLoadingReport: false,
        exportCanceled: false,
    }

    componentWillUnmount() {
        if (this.progressService) {
            try { this.progressService.close(); } catch (e) { }
            this.progressService = null;
        }
    }

    async getFirstSearchResults() {
        this.setState({isModalUploadVisible: false})
        this.handlePaginationOnChange(1)
    }

    async handlePaginationOnChange(currentPage) {
        const fromNum = ((currentPage - 1) * resultsPerPage)
        const {filters} = this.state;

        await this.setState({isLoading: true, searchResultsFromNum: fromNum})

        filters.size = resultsPerPage
        filters.from = fromNum

        const negativeList = await getNegativeListPromise(filters)

        await this.setState({
            isLoading: false,
            negativeList: negativeList.records,
            resultsCurrentPage: currentPage,
            resultsTotalNum: negativeList.total
        })
    }

    async handleSubmitPagination(currentPage) {
        this.handlePaginationOnChange(currentPage)
    }

    async componentDidMount() {
        this.getFirstSearchResults()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.filters !== this.state.filters) {
            this.handlePaginationOnChange(1, this.state.filters);
        }
    }

    handleFilterChange(filterKey, value) {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [filterKey]: value
            },
        }))
    }

    async handleChangeRisk(record, selectedValue) {

        record.riesgoAsignado = selectedValue;

        const changeRiskOK = () => {
            message.success(t('messages.aml.recordUpdated'))
            setTimeout(() => {
                this.handlePaginationOnChange(this.state.resultsCurrentPage);
            }, 2500);
        }

        confirm({
            title: t('messages.aml.confirmRiskChange'),
            okText: t('messages.aml.confirm'),
            cancelText: t('messages.aml.cancel'),
            async onOk() {
                const recordUpdate = await updateNegativeRecordPropmise([record]);
                if (recordUpdate === "OK") {
                    changeRiskOK()
                } else {
                    message.error(t('messages.aml.recordUpdateError'))
                }
            },
        });
    }

    clearFilters() {
        this.setState({filters: emptyFilters}, () => {
            this.handlePaginationOnChange(1);
        });
    }

    selectedRiskFilter() {
        const {filters} = this.state;
        if (filters.riesgo === "") {
            return t('messages.aml.assignedRisk');
        } else if (filters.riesgo === "N") {
            return t('messages.aml.noRisk');
        } else {
            return filters.riesgo;
        }
    }

    renderTableColumns() {
        const {t} = this.props
        const {filters} = this.state;

        const columns = [
            {
                title: <Input size='small'
                              placeholder={t('messages.aml.rutNumber')}
                              value={filters.rut}
                              onChange={(e) => this.handleFilterChange('rut', e.target.value)}
                />,
                dataIndex: 'rut'
            },
            {
                title: <Input size='small'
                              placeholder={t('messages.aml.lastNamePaternal')}
                              value={filters.paterno}
                              onChange={(e) => this.handleFilterChange('paterno', e.target.value)}
                />,
                dataIndex: 'paterno'
            },
            {
                title: <Input size='small'
                              placeholder={t('messages.aml.lastNameMaternal')}
                              value={filters.materno}
                              onChange={(e) => this.handleFilterChange('materno', e.target.value)}
                />,
                dataIndex: 'materno'
            },
            {
                title: <Input size='small'
                              placeholder={t('messages.aml.name')}
                              value={filters.nombre}
                              onChange={(e) => this.handleFilterChange('nombre', e.target.value)}
                />,
                dataIndex: 'nombre'
            },
            {
                title: <Input size='small'
                              placeholder={t('messages.aml.causal')}
                              value={filters.causal}
                              onChange={(e) => this.handleFilterChange('causal', e.target.value)}
                />,
                dataIndex: 'causal'
            },
            {
                title: t('messages.aml.startingDate'),
                dataIndex: 'fechaInicio'
            },
            {
                title: t('messages.aml.endingDate'),
                dataIndex: 'fechaFin'
            },
            {
                title: <Select
                    size='small'
                    placeholder={t("messages.aml.assignedRisk")}
                    value={this.selectedRiskFilter()}
                    onChange={(value) => this.handleFilterChange('riesgo', value)}
                >
                    <Option key="N" value="N" className="optionRisk"> {t("messages.aml.no.risk")} </Option>
                    <Option key="" value="" className="optionRisk"> {t("messages.aml.all")} </Option>
                    {this.insideRiskColor.map(({name, color}) => (
                        <Option key={name} value={name} className="optionRisk">
                            <div style={{width: '100%'}}>
                                <span>{name}</span> &nbsp;&nbsp;
                                <span
                                    className="riskSelector"
                                    style={{
                                        backgroundColor: color
                                    }}
                                ></span>
                            </div>
                        </Option>
                    ))}
                </Select>,
                dataIndex: 'assignedRisk',
                render: (text, record) => {
                    return (
                        <Select
                            size='small'
                            placeholder={t('messages.aml.assignedRisk')}
                            value={record.riesgoAsignado}
                            onChange={(value) => this.handleChangeRisk(record, value)}
                            allowClear
                        >
                            {this.insideRiskColor.map(({name, color}) => (
                                <Option key={name}
                                        value={name}
                                        className="optionRisk">
                                    <div style={{width: '100%'}}>
                                        <span>{name}</span> &nbsp;&nbsp;
                                        <span
                                            className="riskSelector"
                                            style={{
                                                backgroundColor: color
                                            }}
                                        ></span>
                                    </div>
                                </Option>
                            ))}
                        </Select>
                    )

                },
            },
        ]

        return columns
    }

    insideRiskColor = [
        {name: 'BLACK', color: '#000000FF'},
        {name: 'RED', color: '#ee220c'},
        {name: 'ORANGE', color: '#ff9300'},
        {name: 'YELLOW', color: '#fae232'},
        {name: 'GREEN', color: '#598756'},
    ];

    handleUploadClick() {
        this.setState({isModalUploadVisible: true})
    }

    handleOnCancelModalUpload = () => {
        if (this.uploading && this.progressService) {
            try { this.progressService.close(); } catch (e) { }
        }

        this.setState({
            isModalUploadVisible: false,
            uploading: false,
            uploaded: false,
            uploadProgress: 0,
            fileList: [],
            resultsUpload: [],
            pendingFile: null,
            isConfirmModalVisible: false
        });
    }

    cancelExportEvent = () => {
        this.setState({ exportCanceled: true });

        // cerrar SSE
        if (this.progressService) {
            try { this.progressService.close(); } catch (e) { }
            this.progressService = null;
        }

        // limpiar UI
        this.setState({
            exporting: false,
            exportProgress: 0,
            exportError: null,
            downloadingStage: false,
            isLoadingReport: false
        });
    }

    // Validación de archivo
    validateFile = (file) => {
        const { t } = this.props;

        // Validar extensión
        const fileName = file.name.toLowerCase();
        const hasValidExtension = ALLOWED_EXTENSIONS.some(ext => fileName.endsWith(ext));

        if (!hasValidExtension) {
            notification.error({
                message: t('messages.aml.invalidFileFormat'),
                description: `${t('messages.aml.allowedFilesOnly')} ${ALLOWED_EXTENSIONS.join(', ')}`
            });
            return false;
        }

        // Validar tamaño
        if (file.size > MAX_FILE_SIZE_BYTES) {
            const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
            notification.error({
                message: t('messages.aml.fileExceedsSize'),
                description: t('messages.aml.fileSizeDescription', { fileSize: fileSizeMB, maxSize: MAX_FILE_SIZE_MB })
            });
            return false;
        }
        return true;
    }

    // Handlers para modal de confirmación
    handleConfirmUpload = () => {
        const { pendingFile } = this.state;
        this.setState({
            isConfirmModalVisible: false,
            pendingFile: null
        });
        if (pendingFile) {
            this.handleUploadNegativeList(pendingFile);
        }
    }

    handleCancelConfirm = () => {
        this.setState({
            isConfirmModalVisible: false,
            pendingFile: null
        });
    }

    async changeAllowNegAdm(checked) {
        const { t } = this.props
        let result = await changeAllowNegClientPromise(checked)
        if(result.status === 'OK') {
            this.setState({ allowNegAdm: checked })
            notification.success({
                message: t('messages.aml.successfulOperation'),
                description: checked ? t('messages.aml.permissionGranted') : t('messages.aml.permissionDeny')
            })
        }else {
            notification.error({
                message: t('messages.aml.error.load.file'),
                description:t('messages.aml.anErrorOcurredWhileUploadingFile')
            })
        }
    }

    async handleDownload() {
        const { t } = this.props;
        const { filters } = this.state;

        if (this.progressService) {
            try { this.progressService.close() } catch (e) { }
            this.progressService = null;
        }

        await this.setState({
            exporting: true,
            exportProgress: 0,
            exportError: null,
            isLoadingReport: true,
            downloadingStage: false,
            exportCanceled: false
        });

        try {
            const response = await exportNegativeListPromise({
                ...filters,
                clientId: this.context.currentUser.cliente.id
            });

            if (response && response.batchId) {
                this.listenExportProgress(response.batchId);
            } else {
                throw new Error('No se recibió batchId del servidor');
            }
        } catch (e) {
            console.error("Error al iniciar exportación:", e);
            this.setState({
                exportError: 'No se pudo iniciar la exportación',
                isLoadingReport: false
            });
        }
    }

    listenExportProgress(batchId) {
        const {t} = this.props;
        this.progressService = UploadProgressService.listenProgress(
            batchId,
            {
                onProgress: (progressData) => {
                    if (this.state.exportCanceled) return;

                    const value = progressData.progress || 0;
                    const lastProgress = this.state.exportProgress;
                    const stage = progressData.stage;
                    if(value > lastProgress) {
                        this.setState({ exportProgress: value, downloadingStage: stage, exportError: null })
                    }
                },
                onComplete: async (data) => {
                    if (this.state.exportCanceled) return;

                    this.setState({exportProgress: 100, downloadingStage: true});

                    const builtPath = `reportes/${data.folder}/${batchId}.xlsx`;
                    const fileName = data.fileName || 'ListasPropias.xlsx';

                    try {
                        await ReportService.read('/inputFile', {
                            path: builtPath,
                            remove: true
                        }, null, fileName, null, t);

                        notification.success({
                            message: t('messages.aml.successfulOperation'),
                            description: t('messages.aml.successDownload')
                        });
                    } catch (err) {
                        notification.error({message: t('messages.aml.error.download')});
                    } finally {
                        // Limpieza total
                        this.setState({
                            exporting: false,
                            exportProgress: 0,
                            exportError: null,
                            downloadingStage: false,
                            isLoadingReport: false
                        });
                    }
                },
                onInactivity: () => {
                    if (this.state.exportCanceled) return;
                    notification.warning({
                        message: t('messages.aml.warning'),
                        description: t('messages.aml.downloadInactivity'),
                    });
                },
                onError: (error) => {
                    if (this.state.exportCanceled) return;
                    this.setState({
                        exportError: t(error) || 'Error de conexión',
                        exporting: false,
                        isLoadingReport: false
                    });
                }
            }
        );
    }

    handleUploadNegativeList = async (file) => {
        const {t} = this.props;

        this.setState({
            uploading: true,
            uploaded: false,
            uploadProgress: 0,
            fileList: [file],
            stage: 0
        });

        try {
            const result = await uploadNegativeListPromise(file);
            if (result.status === 'OK' && result.batchId) {
                this.setState({stage: 1});

                this.progressService = UploadProgressService.listenProgress(
                    result.batchId,
                    {
                        onProgress: (progressData) => {
                            const data = this.state.progressData || {};
                            if (progressData.result) {
                                data.result = progressData.result;
                                this.setState({stage: 2});
                            }
                            this.setState({uploadProgress: progressData.progress, progressData: data});
                        },
                        onComplete: (data) => {
                            //const {progressData} = this.state;
                            let resultsUpload = [];
                            const results = data.result || {};
                            for (let key in results) {
                                let line = '';
                                if (key === 'OK') line = t('messages.aml.loadedEntities') + ': ';
                                else if (key === 'EN01') line = t('messages.aml.rut.error.processing') + ': ';
                                else if (key === 'EN02') line = t('messages.aml.line.error.processing') + ': ';
                                else line = t('messages.aml.recordsWithErrors') + ': ';
                                line += results[key];
                                resultsUpload.push(line);
                            }

                            this.setState({
                                resultsUpload,
                                uploading: false,
                                uploaded: true,
                                fileList: [],
                                stage: 3
                            });

                            notification.success({
                                message: t('messages.aml.successfulOperation'),
                                description: t('messages.aml.processSuccess')
                            });
                            this.handlePaginationOnChange(this.state.resultsCurrentPage);
                        },
                        onInactivity: () => {
                            console.log("Inactividad detectada en la carga de archivo.");
                            notification.warning({
                                message: t('messages.aml.warning'),
                                description: t('messages.aml.uploadInactivity'),
                            });
                        },
                        onError: (error) => {
                            const descriptionText = error ? t(error) : t('messages.aml.anErrorOcurredWhileUploadingFile');

                            notification.error({
                                message: t('messages.aml.error.load.file'),
                                description: descriptionText
                            });

                            this.setState({
                                uploading: false,
                                uploaded: false
                            });
                        }
                    }
                );
            } else {
                throw new Error(t('messages.aml.processError'));
            }
        } catch (error) {
            notification.error({
                message: t('messages.aml.error.load.file'),
                description: t('messages.aml.anErrorOcurredWhileUploadingFile')
            });
            this.setState({
                uploading: false,
                uploaded: false
            });
        }
    }

    render() {
        const {t} = this.props
        const {
            isDownloading,
            isLoading,
            isModalUploadVisible,
            negativeList,
            allowNegAdm,
            resultsCurrentPage,
            resultsTotalNum,
            uploading,
            uploaded,
            uploadProgress,
            resultsUpload,
            pendingFile,
            isConfirmModalVisible,
            stage,
            exporting,
            exportProgress,
            exportError,
            downloadingStage
        } = this.state

        const propsUpload = {
            accept: ".xlsx,.txt",
            name: 'file',
            multiple: false,
            showUploadList: false,
            beforeUpload: (file) => {
                if (!this.validateFile(file)) {
                    return false;
                }
                // Guardar archivo y mostrar modal de confirmación
                this.setState({
                    pendingFile: file,
                    isConfirmModalVisible: true
                });
                return false; // Prevent auto-upload
            }
        }

        const {Dragger} = Upload

        return (
            <div className="admin-lists">

                <div className="tools-area">
                    <div style={{float: 'left', color: '#fff'}}>
                        <Switch checked={allowNegAdm}
                                onChange={(checked) => this.changeAllowNegAdm(checked)}/>&nbsp;&nbsp;Admin. Gesintel
                    </div>

                    <Button type="primary" icon={isDownloading ? 'loading' : 'cloud-download'} disabled={isDownloading}
                            onClick={this.handleDownload.bind(this)}>{t('messages.aml.download')}</Button>&nbsp;
                    <Button type="primary" icon="upload"
                            onClick={this.handleUploadClick.bind(this)}>{t('messages.aml.uploadFile')}</Button>&nbsp;
                    <Button type="primary" icon="close"
                            onClick={this.clearFilters.bind(this)}>{t('messages.aml.clearAllFilters')}</Button>

                </div>

                <div className="table-wrapper">
                    <Table
                        columns={this.renderTableColumns()}
                        dataSource={negativeList}
                        pagination={{
                            current: resultsCurrentPage,
                            total: resultsTotalNum,
                            pageSize: resultsPerPage,
                            onChange: this.handleSubmitPagination.bind(this),
                            showSizeChanger: false,
                            showTotal: (total, range) => `${range[0]}-${range[1]} ${t('messages.aml.of')} ${total} ${t('messages.aml.entries')}`
                        }}
                        size="small"
                        loading={isLoading}
                    />
                </div>

                <Modal
                    onCancel={this.handleOnCancelModalUpload}
                    onOk={uploaded ? this.getFirstSearchResults.bind(this) : null}
                    visible={isModalUploadVisible}
                    title={t('messages.aml.uploadFile')}
                    destroyOnClose={true}
                    footer={
                        uploaded ? [
                            <Button key="close" onClick={this.handleOnCancelModalUpload}>
                                {t('messages.aml.btnClose')}
                            </Button>
                        ] : uploading ? null : [
                            <Button key="cancel" onClick={this.handleOnCancelModalUpload}>
                                {t('messages.aml.cancel')}
                            </Button>
                        ]
                    }
                >

                    {uploading ? (
                        <>
                            <div>
                                {stage === 0 ? t('messages.aml.uploadingFile')
                                    : stage === 1 ? t('messages.aml.processingFile')
                                        : stage === 2 ? t('messages.aml.updatingRecords')
                                            : stage === 3 && t('messages.aml.finished')
                                }
                            </div>
                            <Progress
                                type="line"
                                percent={uploadProgress}
                                style={{padding: '20px 0px'}}
                            />
                        </>
                    ) : uploaded ? (
                        <List
                            header={<h3>{t('messages.aml.results')}</h3>}
                            bordered
                            dataSource={resultsUpload}
                            renderItem={(item) => <List.Item>{item}</List.Item>}
                        />
                    ) : (
                        <Dragger {...propsUpload} >
                            <p className="ant-upload-drag-icon">
                                <Icon type="inbox"/>
                            </p>
                            <p className="ant-upload-text">{t('messages.aml.uploadFileInstructions')}</p>
                        </Dragger>
                    )}
                </Modal>

                {/* Modal de confirmación de carga */}
                <Modal
                    visible={isConfirmModalVisible}
                    title={t('messages.aml.confirmUploadTitle')}
                    onOk={this.handleConfirmUpload}
                    onCancel={this.handleCancelConfirm}
                    okText={t('messages.aml.confirm')}
                    cancelText={t('messages.aml.cancel')}
                >
                    <p>{t('messages.aml.confirmUploadQuestion', {fileName: pendingFile?.name})}</p>
                    <p>{t('messages.aml.size')}: {pendingFile ? (pendingFile.size / (1024 * 1024)).toFixed(2) : 0} MB</p>
                </Modal>


                <Modal
                    visible={exporting}
                    closable={!!exportError}
                    maskClosable={false}
                    footer={
                        exportError ? [
                            <Button key="close" onClick={() => this.setState({ exporting: false, exportError: null })}>
                                {t('messages.aml.btnClose')}
                            </Button>
                        ] : [
                            <Button key="cancel" onClick={this.cancelExportEvent}>
                                {t('messages.aml.cancel')}
                            </Button>
                        ]
                    }
                >
                    {exportError ? (
                        <div style={{ color: '#f5222d', textAlign: 'center' }}>
                            <Icon type="close-circle" style={{ fontSize: 24, marginBottom: 10 }} />
                            <p>{exportError}</p>
                        </div>
                    ) : (
                        <div style={{ textAlign: 'left' }}>
                            <p>
                                {downloadingStage ? t('messages.aml.downloadingFile') : t('messages.aml.generatingExcel')}
                            </p>

                            <Progress percent={Math.round(exportProgress)} />
                        </div>
                    )}
                </Modal>

            </div>
        )
    }
}

export default withTranslation()(AdminLists)
